<template>
    <div class="exam-result-management">
        <h3> 계정관리 > 병원코드 관리</h3>
        <div class="account-card-box">
            <div class="account-toolbar-row">
                <select v-model="searchType" class="account-toolbar-select">
                    <option value="allHospital">전체</option>
                    <option value="hospital">병원명</option>
                    <option value="use">사용여부</option>
                </select>
                <input v-model="searchKeyword" class="account-toolbar-inp" placeholder="검색어 입력" />
                <button class="account-toolbar-btn" @click="fetchAccounts()">검색</button>
            </div>
            <div class="account-btns-action">
                <button class="account-btn" @click="deleteSelected">삭제</button>
                <button class="account-btn" @click="editSelected">수정</button>
                <button class="account-btn" @click="registerAccount">등록</button>
            </div>
            <table class="account-list-table">
                <thead>
                <tr>
                    <th><input type="checkbox" :checked="allSelected" @change="toggleAll" /></th>
                    <th>병원명</th>
                    <th>사용여부</th>
                    <th>병원 인원</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="account in accountList" :key="account.instCD" >
                    <td>
                        <input type="checkbox" v-model="selectedIds" :value="account.instCD" />
                    </td>
                    <td>{{ account.instName }}</td>
                    <td>{{ account.useYN === 'Y' ? '활성화' : '비활성화' }}</td>
                    <td>{{ account.userCuont }}</td>
                </tr>
                <tr v-if="accountList.length === 0">
                    <td colspan="6" style="color:#9ab2ca;">검색 결과가 없습니다.</td>
                </tr>
                </tbody>
            </table>

            <pagination
                :total-items="totalCount"
                :page-size="pageSize"
                v-model="currentPage"
                @page-change="onPageChange"
            />
        </div>
    </div>
</template>


<script>
import api, {urls} from '@/api'
import Pagination from "@/components/common/Pagination.vue";

export default {
    components: { Pagination },
    meta: {
        title: "병원코드 관리"
    },
    data() {
        return {
            searchType: "allHospital", // 검색 타입
            searchKeyword: "", // 검색어
            accountList: [], // 계정 목록
            selectedIds: [], // 선택된 계정 id
            allSelected: false, // 전체선택 체크박스

            currentPage: 1,       // 현재 페이지 번호
            pageSize: 10,         // 한 페이지에 보여줄 개수 (필요에 따라 변경 가능)
            totalPages: 1,        // 총 페이지 수 (백엔드에서 받아옴)
            totalCount: 0,        // 총 데이터 개수 (옵션, 백엔드에서 받아옴)
            isLoading: false
        };
    },
    methods: {
        onPageChange(page) {
            if (this.searchKeyword?.trim()) {
                this.fetchAccounts(page);
            } else {
                this.getlist(page);
            }
        },
        // 계정 목록 조회 (검색)
        fetchAccounts(page = 1) {
            const payload = {
                searchType: this.searchType,
                searchText: this.searchKeyword,
                startIndex: page,
                pageRow: this.pageSize
            };
            if (this.searchType === 'use' || this.searchType === 'allHospital') {
                if (this.searchKeyword === '활성화') {
                    payload.searchText = 'Y';
                } else if (this.searchKeyword === '비활성화') {
                    payload.searchText = 'N';
                }
            }

            api.get(urls.account.hospitalSearch, {params: payload })
                .then(res => {
                    this.accountList = (res.data.list || res.data || []).map(acc => ({
                        instCD: acc.inst_cd || '',
                        instName: acc.inst_name || '',
                        useYN: acc.use_yn || '미정',
                        userCuont: acc.user_count || '0',
                    }))
                    this.totalCount = res.data.totalCount || this.accountList.length
                    this.totalPages = Math.ceil(this.totalCount / this.pageSize)
                    this.currentPage = page
                    this.selectedIds = []
                    this.allSelected = false
                })
                .catch(error => {
                    alert('병원 검색 기능이 실패했습니다.')
                    this.accountList = []
                    this.selectedIds = []
                    this.allSelected = false
                    this.totalCount = 0
                    this.totalPages = 1
                    console.error(error)
                })
        },
        getlist(page = 1) {
            api.get(urls.account.hospitalList, {params: {
                    startIndex: page,
                    pageRow: this.pageSize
                }})
                .then(res => {
                    this.accountList = (res.data.list || res.data || []).map(acc => ({
                        instCD: acc.inst_cd || '',
                        instName: acc.inst_name || '',
                        useYN: acc.use_yn || '미정',
                        userCuont: acc.user_count || '0',
                    }))
                    this.totalCount = res.data.totalCount || this.accountList.length
                    this.totalPages = Math.ceil(this.totalCount / this.pageSize)
                    this.currentPage = page
                    this.selectedIds = []
                    this.allSelected = false
                })
                .catch(err => {
                    alert('병원 목록 조회 실패')
                    this.accountList = []
                    this.selectedIds = []
                    this.allSelected = false
                    this.totalCount = 0
                    this.totalPages = 1
                    console.error(err)
                })
        },
        deleteSelected() {
            if (this.selectedIds.length === 0) {
                alert('삭제할 대상을 선택하세요.')
                return
            }

            // 삭제 확인 다이얼로그 표시
            const confirmed = window.confirm(
                `${this.selectedIds.length}개의 계정을 정말로 삭제하시겠습니까?`
            )

            // 사용자가 '취소'를 누르면 삭제 중단
            if (!confirmed) {
                return
            }

            api.post(urls.account.hospitalDelete, {
                idList: this.selectedIds
            })
                .then(res => {
                    if (res.data === 1) {
                        alert('병원 삭제에 성공했습니다.')
                        this.fetchAccounts()
                    } else {
                        const errorMsg = res.data.message || '병원 삭제에 실패하였습니다.'
                        alert(errorMsg)
                    }
                })
                .catch(error => {
                    alert('병원 삭제기능이 실패했습니다.')
                    console.error(error)
                    this.fetchAccounts()
                })
        },
        // 수정
        async editSelected() {
            if (this.selectedIds.length !== 1) {
                alert("수정할 항목을 한 개만 선택하세요.");
                return;
            }
            this.$router.push({
                name: 'HospitalCodeManagement',
                query: { id: this.selectedIds[0]}
            });
        },
        // 전체선택/해제
        toggleAll(event) {
            this.allSelected = event.target.checked;
            if (this.allSelected) {
                this.selectedIds = this.accountList.map((acc) => acc.instCD);
            } else {
                this.selectedIds = [];
            }
        },
        // 등록
        registerAccount() {
            this.$router.push({
                name: 'HospitalCodeManagement',
                query: {}
            });
        },

    },
    mounted() {
        this.getlist();
    },
};
</script>

